<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <div class="main-div">
        <el-container class="parentDiv">
          <div class="SID0007_SecondNewsScrollPage" v-loading.fullscreen.lock="fullscreenLoading">
            <!-- Breadcrumb section -->
            <section>
              <el-breadcrumb separator-class="el-icon-arrow-right" class="SearchRegisterLink">
                <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '' }">サムネイル表示 (日経記事)</el-breadcrumb-item>
              </el-breadcrumb>
            </section>
            <!--Fix for BT08460_EXTERNAL-1596 by MA starts here-->
            <section>
                <el-dialog title=""
                    :visible.sync="dialogVisible "
                    close="false"
                    :close-on-click-modal="false"
                    class="SID0009_DilaogDiv PrintHideArea">
                    <el-container>
                      <div class="SID0009__popupScreen3">
                          <div class="FirstSpan3">
                              <span>要求された記事は表示できません。</span>
                          </div>  
                          <div class="ButtonClose3">
                              <el-button type="info" plain @click="closeTab">閉じる</el-button>
                          </div>
                      </div>
                    </el-container>
                </el-dialog>
            </section>
            <!--Fix for BT08460_EXTERNAL-1596 by MA ends here-->
              <span class="prev prevButtonTopSpan" v-show="showPrev">
                <el-button type="primary" @click="prev()" plain>前へ</el-button>
              </span>
              <span class="next nextButtonTopSpan" v-show="showNext">
                <el-button type="primary" @click="next()" plain>次へ</el-button>
              </span>
              <!-- First slider section start -->
              <div class="owl-carousel owl-theme" v-if="refresh" v-carousel>
                <div class="divScrollSection" v-for="(scArticle,index) in getArraySC" v-bind:key="index">
                  <!-- Topic Header section -->
                  <section>
                    <el-row>
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 START-->
                      <el-col :span="3" :xs="24">
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 END-->
                        <div class="newsScrollImage">
                          <img src="../../assets/image/Nikkie-logo-web.svg" alt="LOGO" />
                        </div>
                      </el-col>
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 START-->
                      <el-col :span="21" :xs="24">
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 END-->
                        <div class="TopicHeaderText">
                          <span>{{ scArticle.article_title }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-divider class="newsScrollHeaderTop"></el-divider>
                    <el-row>
                      <el-col :span="3" class="ColumnFirst">{{ scArticle.media_name }}</el-col>
                      <el-col :span="6">{{ scArticle.issue_date }}</el-col>
                      <el-col :span="3">{{ scArticle.articleEdition }}</el-col>
                      <el-col :span="3">{{ scArticle.frame_no }}面 </el-col>
                      <el-col :span="3">{{ scArticle.char_count }}文字</el-col>
                    </el-row>
                    <el-divider class="newsScrollHeaderBottom"></el-divider>
                  </section>
                  <!-- Notic information section -->
                  <section>
                    <el-row>
                      <el-col>
                        <div class="noticInformation">
                          <span>&lt;コメント&gt;</span>
                          <span v-html= "scArticle.article_comment"></span>
                        </div>
                      </el-col>
                    </el-row>
                    <div>
                      <el-divider class="newsScrollHeaderSubTop"></el-divider>
                    </div>
                    <div class="newsScrollHeaderSub">
                      <span>&lt;検索語&gt;</span>
                      <span>{{ scArticle.search_word }}</span> 
                    </div>
                    <el-divider class="newsScrollHeaderMiddle"></el-divider>
                  </section>
                  <!-- Font Size Resize Section -->
                  <section>
                    <el-row class="font__row">
                      <span class="font__size__select">文字サイズ</span>
                      <el-button
                        type="primary"
                        plain
                        v-on:click="FontDecrease"
                        class="activeFont"
                        v-bind:class="{ activeButton: isActive }"
                      >小</el-button>
                      <el-button
                        type="primary"
                        plain
                        v-on:click="FontReset"
                        class="activeFont"
                        v-bind:class="{ activeButton: isMedActive }"
                      >中</el-button>
                      <el-button
                        type="primary"
                        plain
                        v-on:click="FontIncrease"
                        class="activeFont"
                        v-bind:class="{ activeButton: isBigActive }"
                      >大</el-button>
                    </el-row>
                    <div class="newsFontSizeChange smallFontSize mediumFontSize largeFontSize">
                      <!-- 2024/08/05  #17046 No.20  START -->
                      <div v-for="(traceCaption,index2) in scArticle.trace_image_info" v-bind:key="index2">
                        <ImageComponent v-bind:Index="index2" v-bind:ImagePath="traceCaption.image_path" v-bind:ArticleId="scArticle.article_id" v-bind:SerialNo="traceCaption.serial_no" v-if="scArticle.article_id==getArraySC[index].article_id" />
                      </div>
                      <!-- 2024/08/05  #17046 No.20  END -->
                      <!-- Change by CK/MK for backlog Id: 1733 added class for article text  -->
                      <span class="body__">&lt;本文&gt;</span>
                      <br>
                      <span class="body__text" v-html="scArticle.article_text"></span> 
                      <br>
                      <span v-html="CopyRightText" class="body__"></span> 
                      <!-- 2024/08/05  #17046 No.20  START -->
                      <hr class="customDivider">
                      <!-- 2024/08/05  #17046 No.20  END -->
                    </div>
                    <!-- 2024/08/05  #17046 No.20  START -->
                    <!-- <el-divider class="newsScrollHeaderSubBottom"></el-divider> -->
                  <!-- </section> -->
                  <!-- Slider section -->
                  <!-- <section> -->
                    <!-- <div class="LinkThumbnailPrint"> -->
                    <!-- 2025/03/10  #19043  START -->
                    <div v-if="!nikkei_media_name_ev.includes(scArticle.media_name.trim()) || scArticle.media_name.trim() == '日経ヴェリタス'" class="LinkThumbnailPrint">
                    <!-- 2025/03/10  #19043  END -->
                      <!-- 2024/08/05  #17046 No.20  END -->
                      <!-- 2022/08/09  #13105  START -->
                      <!-- <div v-if="sc_user_authority == 5 && scArticle.scPdfPrintDisplayFlag == true"> -->
                      <div v-if="sc_user_authority == 5 && scArticle.no_image_flag == false">
                      <!-- 2022/08/09  #13105  END -->
                        <!-- Change by CK for backlog Id: 1420  -->
                          <el-link :underline="false" type="primary"  class="ArticleLink">
                            サムネイルをクリックすると記事原文を表示します。
                            <el-link :underline="false" type="primary"  class="ArticleLink">印刷は<b @click="pdfPrint(scArticle.article_id,scArticle.data_section)" class="ArticlePrintText">ここ</b>から指定してください。</el-link>
                          </el-link>
                      </div>
                      <!-- 2022/08/09  #13105  START -->
                      <!-- <div v-else-if="sc_user_authority == 2 || scArticle.scPdfPrintDisplayFlag == false"></div> -->
                      <div v-else-if="sc_user_authority == 2 || scArticle.no_image_flag == true"></div>
                      <!-- 2022/08/09  #13105  END -->
                      <div v-else-if="sc_user_authority == 3">
                          <el-link :underline="false" type="primary"  class="ArticleLink">
                            サムネイルをクリックすると記事原文を表示します。
                          </el-link>
                      </div>
                      <el-row>
                        <!-- 2021/02/23 #10026 START-->
                        <!--<el-carousel indicator-position="none" :autoplay="false">-->
                        <el-carousel indicator-position="none" :autoplay="false" :arrow="scArticle.scimagelink.length==1?'never':'hover'">
                          <!-- 2021/02/23 #10026 END-->
                          <el-carousel-item v-for="item in scArticle.scimagelink" :key="item" >
                            <!-- 2022/08/31  #13105  START -->
                            <!-- <div v-if="(sc_user_authority == 3 || sc_user_authority == 5) && scArticle.scPdfPrintDisplayFlag == true" class="slider_outer"> -->
                            <div v-if="(sc_user_authority == 3 || sc_user_authority == 5) && scArticle.no_image_flag == false" class="slider_outer">
                            <!-- 2022/08/31  #13105  END -->
                              <el-image :src="item" @error="replaceByDefault($event,index)" alt="ArticleSnap" class="sliderImage" @click="sendToErrorDisplay(scArticle.article_id)"/>
                            </div>
                            <div v-else class="slider_outer">
                              <el-image :src="item" @error="replaceByDefault($event,index)" alt="ArticleSnap" class="sliderImage b-none" />
                            </div>
                          </el-carousel-item>
                        </el-carousel>
                      </el-row>
                    </div>
                  </section>
                </div>
              </div>
              <!-- First slider section end -->
              <span class="prev prevBottomSpan" v-show="showPrev">
                <el-button type="primary" @click="prev()" plain>前へ</el-button>
              </span>
              <span class="next nextButtonBottomSpan" v-show="showNext">
                <el-button type="primary" @click="next()" plain>次へ</el-button>
              </span>
            <!-- Full container section End -->
          </div>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<!-- BT08460_EXTERNAL-1572 issue fix by MA - Oct 29 -->
<script type="text/javascript" src="../../../public/script/owl.carousel.js"></script>
<script>
import Header from "../common/header.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import "splitpanes/dist/splitpanes.css";
import Vue from 'vue'
import "swiper/dist/css/swiper.css";
import Common from '../../common/CommonFunc.js';
import router from "../../router";
// 2022/08/09  #13105  START
//import error_image from "../../assets/image/errorThumbnailImage@3_200x200.png";
import error_image_no_image from "../../assets/image/errorThumbnail@3_200x200.png";
import error_image_no_auth from "../../assets/image/errorThumbnailImage@3_200x200.png";
// 2022/08/09  #13105  END
// BT08460_EXTERNAL-1572 issue fix by MA - Oct 29
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel';
// 2024/08/05  #17046 No.20  START
import ImageComponent from "../common/imageComponent.vue";
// 2024/08/05  #17046 No.20  END
// 2024/08/19  #13914  START
import { onMounted } from 'vue';
// 2024/08/19  #13914  END
export default {
// 2024/08/19  #13914  START
  setup() {
    onMounted(() => {
      if (/iP(hone|od|ad).*Safari/i.test(navigator.userAgent)) {
        // Safariの場合、キャッシュ表示のままになるので強制リロード
        window.location.replace(window.location.href);
      }
      });
    },
// 2024/08/19  #13914  END
  name: "NewsScroll",
  props: {
    items: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Header,
    FooterComponent,
    // 2024/08/05  #17046 No.20  START
    ImageComponent,
    // 2024/08/05  #17046 No.20  END
  },
  data() {
    return {
      // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30 starts here
      showPrev: false,//For Mail functionality
      showNext: true,
      // 2022/02/14  #12197  START
      repeat:false,
      // 2022/02/14  #12197  END
      sc_user_authority:'5',
      nextSlideDataSection: 2,
      prevSlideDataSection: 2,
      getArraySC: [],
      // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30 ends here
      hideNavButton: true,
      hideNextButton_0006: false,
      refresh: false,
      fullscreenLoading: false,
      logo:Common.SC_Logo,
      sc_pdf_print_flag: false,
      isActive: false,
      isMedActive: true,
      isBigActive: false,
      CopyRightText: "",
      userId:'',
      contractId:'',
      theme_browsing:false,
      contract_code:'',
      message_info: [],
      hidePrevButton_0006: false,
      user_group_name: "",
      // 2024/08/05  #17046 No.20  START
      // 2025/02/27  #19043  START
      nikkei_media_name_ev: "日本経済新聞電子版,NIKKEI Mobility,NIKKEI GX | Green Transformation,NIKKEI Tech Foresight,NIKKEI FT the World,日経ヴェリタス（デジタル版）",
      // 2025/02/27  #19043  END
      // 2024/08/05  #17046 No.20  END
      is_mail:false,
      fontSizeChangeFlag: 1,
      inputParam: "",
      currentNewsCount: 0,
      currentStartNum:1,
      currentAID:"",
      dialogVisible: false, // Fix for BT08460_EXTERNAL-1596 by MA
      queryparam:'',
      frommail:false,
      currentSID:'',
      currentArticleNo:0,
      loadNum: 10,
      fromSID:'',
    };
  },
  methods: {
    //for next button
    next(){
      this.currentArticleNo = this.currentArticleNo + 1;
      this.nextSlideDataSection = this.getArraySC[this.currentArticleNo].data_section; 
      if(this.nextSlideDataSection == '1'){
        Vue.prototype.$session.set('CurrentRowNo',this.currentArticleNo);
        if(router.currentRoute.name != '0006'){
          router.push({name:'0006',query: this.queryparam});
        }
      }else{
        // 2021/12/7  #12178  START
        this.prevSlideDataSection = this.getArraySC[this.currentArticleNo - 1].data_section;
        var mail_processor = new Common.Mail_URL_Processor(this.$route.query);
        var having_mail_key = mail_processor.is_data_present("is_mail");
        var bodytextview_requestlog = {
            data_info:[{
            contract_id: this.contractId,
            data_section: 2,
            user_id: this.userId,
            read_count:1,
            request_div:3,
            article_id: this.getArraySC[this.currentArticleNo].article_id,
            user_group_name: this.user_group_name,
          }],
          is_mail:having_mail_key
        }
        if(!this.dialogVisible){
          this.$store.dispatch('communication0008/pdfRequestDisplay',bodytextview_requestlog);
        }
        // 2021/12/7  #12178  END
      }
    },
    //for prev button
    prev(){
      this.currentArticleNo = this.currentArticleNo - 1;
      this.prevSlideDataSection = this.getArraySC[this.currentArticleNo].data_section;
      if(this.prevSlideDataSection == '1'){
        Vue.prototype.$session.set('CurrentRowNo',this.currentArticleNo);
        if(router.currentRoute.name != '0006'){
          router.push({name:'0006',query: this.queryparam});
        }
      }else{
        // 2021/12/7  #12178  START
        this.prevSlideDataSection = this.getArraySC[this.currentArticleNo + 1].data_section;
            var mail_processor = new Common.Mail_URL_Processor(this.$route.query);
            var having_mail_key = mail_processor.is_data_present("is_mail");
            var bodytextview_requestlog = {
                data_info:[{
                contract_id: this.contractId,
                data_section: 2,
                user_id: this.userId,
                read_count:1,
                request_div:3,
                article_id: this.getArraySC[this.currentArticleNo].article_id,
                user_group_name: this.user_group_name,
              }],
              is_mail:having_mail_key
            }
            if(!this.dialogVisible){
              this.$store.dispatch('communication0008/pdfRequestDisplay',bodytextview_requestlog);
            }
        // 2021/12/7  #12178  END
      }
    },
    // Fix for BT08460_EXTERNAL-1596 by MA starts here
    closeTab(){
      this.$LogButtonEvent("0007","Close");
      this.$LogMethodIN("0007","closeTab");
      router.push("0002");
      this.$LogMethodOut("0007","closeTab");
    },
    // Fix for BT08460_EXTERNAL-1596 by MA ends here
    replaceByDefault(event, index) {
      this.getArraySC[index].scPdfPrintDisplayFlag = false;
      // 2022/08/09  #13105  START
      // event.target.src = error_image;
      if(this.getArraySC[index].no_image_flag == true)
      {
        // 原文提供不可場合、「この記事は、著作権処理等の関係で記事原文やサムネイルのご提供ができません。」
        event.target.src = error_image_no_auth;
      }
      else{
        // 原文提供可場合、「この記事は、サムネイルが取得できませんでした。」
        event.target.src = error_image_no_image;
      }
      // 2022/08/09  #13105  END
    },
    getMessageInfoFromSession(){
      var message_info = this.message_info;
      for(var u=0;u<message_info.length;u++)
      {
        if(message_info[u].message_key == "kpCopyright")
        {
          this.CopyRightText = message_info[u].configuration_value;
        }
      }
    },
    FontDecrease() {
      this.$LogButtonEvent("0007","Small");
      this.$LogMethodIN("0007","FontDecrease");
      $(".smallFontSize span").css("font-size", "calc(10.4pt * 0.8)");
      this.isActive = true;
      this.isMedActive = false;
      this.isBigActive = false;
      this.fontSizeChangeFlag = 1;
      this.$LogMethodOut("0006","FontDecrease");
    },
    FontReset() {
      this.$LogButtonEvent("0007","Medium");
      this.$LogMethodIN("0007","FontReset");
      $(".mediumFontSize span").css("font-size", "10.4pt");
      this.isActive = false;
      this.isMedActive = true;
      this.isBigActive = false;
      this.fontSizeChangeFlag = 2;
      this.$LogMethodOut("0007","FontReset");
    },
    FontIncrease() {
      this.$LogButtonEvent("0007","Large");
      this.$LogMethodIN("0007","FontIncrease");
      $(".largeFontSize span").css("font-size", "calc(10.4pt * 1.3)");
      this.isActive = false;
      this.isMedActive = false;
      this.isBigActive = true;
      this.fontSizeChangeFlag = 3;
      this.$LogMethodOut("0007","FontIncrease");
    },
    sendToErrorDisplay(article_id){
      this.$LogButtonEvent("0007","Close");
      this.$LogMethodIN("0007","sendToErrorDisplay");
      // 2022/02/14  #12197  START
      if(this.repeat){
        return
      }
      this.repeat = true;
      // 2022/02/14  #12197  END
      var pdfValues = {
        pdf_flag: 1,
        article_info:[
          {
            article_id: article_id,
            data_section: 2
          }
        ],
        user_id: this.userId,
        contract_code: this.contract_code,
        theme_browsing: this.theme_browsing,
        // 2021/10/11  #11849  START
        display_id: 'SID0007',
        // 2021/10/11  #11849  END
        is_mail:this.is_mail
      };
      var printSuccessValues = {
        data_info:[{
        contract_id: this.contractId,
        data_section: 2,
        user_id: this.userId,
        read_count:1,
        request_div:1,
        article_id: article_id,
        user_group_name: this.user_group_name,
        
        }],
        is_mail:this.is_mail
      }
      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            if(action === "confirm"){
              /*******BT08460_EXTERNAL-1539 issue fix*******/
              this.$session.set('pdfCombinedArray', printCombinedArray);
              let routeData = this.$router.resolve({name: '0001-001'}); 
              window.open(routeData.href, '_blank');
              // 2022/02/14  #12197  START
                setTimeout(() => {
                        this.repeat = false;
                    }, 60);
                // 2022/02/14  #12197  END
              /*this.fullscreenLoading = true;
              this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
                this.fullscreenLoading = false;
              })
              .catch(() => {
                this.fullscreenLoading = false;
                // 2022/02/14  #12197  START
                this.repeat = false;
                // 2022/02/14  #12197  END
              })*/
              /*******BT08460_EXTERNAL-1539 issue fix*******/
              done();
            }else{
              // 2022/02/14  #12197  START
              this.repeat = false;
              // 2022/02/14  #12197  END
              done();
            }
          }
        });
      }
      else
      {
        /*******BT08460_EXTERNAL-1539 issue fix*******/
        this.$session.set('pdfCombinedArray', printCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        // 2022/02/14  #12197  START
        setTimeout(() => {
                this.repeat = false;
            }, 60);
        // 2022/02/14  #12197  END
        /*this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })*/
        /*******BT08460_EXTERNAL-1539 issue fix*******/
      }
      this.$LogMethodOut("0007","sendToErrorDisplay");
    },
    createData(){
      var session_scArticle  = this.getNikkieArticledata;
      // Fix for BT08460_EXTERNAL-1596 by MA
      if(session_scArticle != "" && session_scArticle.length > 0){
        this.fullscreenLoading = false;
        this.getArraySC = session_scArticle;
      }else{
        this.dialogVisible = true; // Fix for BT08460_EXTERNAL-1596 by MA
        this.fullscreenLoading = false;
      }
    },
    pdfPrint(articleid,datasection){
      var pdfValues = {
        pdf_flag:2,
        article_info:[
          {
            article_id: articleid,
            data_section: datasection
          }
        ],
        user_id: this.userId,
        contract_code: this.contract_code,
        theme_browsing: this.theme_browsing,
        // 2021/10/11  #11849  START
        display_id: 'SID0007',
        // 2021/10/11  #11849  END
        is_mail:this.is_mail
      }
      var printSuccessValues = {
        data_info:[{
          contract_id: this.contractId,
          data_section: datasection,
          user_id: this.userId,
          read_count:1,
          request_div:2,
          article_id: articleid,
          user_group_name: this.user_group_name,
        }],
        is_mail:this.is_mail
      }
      var printCombinedArray = [];
      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPrintMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            if(action === "confirm")
            {
              this.fullscreenLoading = true;
              this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                this.fullscreenLoading = false;
              })
              .catch(() => {
                this.fullscreenLoading = false;
              })
              done();
            }
            else
            {
              done();
            }
          }
        });
      }
      else
      {
        this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
    },
    getConfigurationFromSession(){
      //get the user group linkage info value from the session
      var user_group_linkage = this.getUserGroupLinkageInfo
      for(var k=0;k<user_group_linkage.length;k++)
      {
        if(user_group_linkage[k].data_section == 1 || user_group_linkage[k].data_section == 2)
        {
          if(user_group_linkage[k].media_window_size == 3)
          {
            this.isActive = false;
            this.isMedActive = false;
            this.isBigActive = true;
            this.fontSizeChangeFlag = 3;
          }
          else if(user_group_linkage[k].media_window_size == 2)
          {
            this.isActive = false;
            this.isMedActive = true;
            this.isBigActive = false;
            this.fontSizeChangeFlag = 2;
          }
          else
          {
            this.isActive = true;
            this.isMedActive = false;
            this.isBigActive = false;
            this.fontSizeChangeFlag = 1;
          }
        }
        else
        {
          //no action needed
        }
      }
    },
  },
  mounted(){
    this.fullscreenLoading = true;
    // 2021/10/11  #11849  SATRT
    if(!this.getUserGroup_News_Article_Flag || !this.getSC_Article_Flag){
      this.dialogVisible = true
    }
    // 2021/10/11  #11849  END
    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    //get the pdf print flag from the session
    this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag;
    this.user_group_name = this.getUserGroupName;
    //get the contract code value from session
    this.contract_code = this.getContractCode;

    this.sc_user_authority =  this.getScUserAuthority;
    this.canViewText = this.getMC_Text_View_Flag;

    this.message_info = this.getMessageInfo;
    // For print icon enable 
    this.sc_pdf_print_flag = this.getSC_Pdf_Print_Flag;

    var mail_processor = new Common.Mail_URL_Processor(this.$route.query);
    var having_mail_key = mail_processor.is_data_present("is_mail");
    var getDataArticleIds = [];
    if(having_mail_key)
    {
      // 2026/03/09 #20277 START
      var ua = navigator.userAgent;
      var isMobileSafari = /iPhone|iPad|iPod/.test(ua) && /WebKit/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
      if (isMobileSafari && window.location.search.indexOf('v=') === -1) {
        history.replaceState(null, '', '/?v=' + Date.now() + window.location.hash);
      }
      // 2026/03/09 #20277 END

      var mc_articleids = mail_processor.get_mc_article_details()
      if(mc_articleids.length>0)
      {
        Array.prototype.push.apply(getDataArticleIds,mc_articleids); 
      }
      var sc_articleids = mail_processor.get_sc_article_details()
      if(sc_articleids.length>0)
      {
        Array.prototype.push.apply(getDataArticleIds,sc_articleids); 
      }
      this.queryparam = this.$route.query
      this.frommail = true
    }
    if(!this.dialogVisible){
      if(getDataArticleIds.length > 0){
        //Removed this code since it is not calling the API on same tab  - mail link carousel issue fix by DK - Nov 04
        // BT08460_EXTERNAL-1572 mail link carousel issue fix by GB - Nov 03
        // if(this.getNewsArticledata.length > 0)
        // {
        //   this.refresh = true;
        //   this.createData();

        //   if(Vue.prototype.$session.get('CurrentNewsCount'))
        //   {
        //     this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
        //   }

        //   if(Vue.prototype.$session.get('CurrentRowNo'))
        //   {
        //     this.currentArticleNo= Vue.prototype.$session.get('CurrentRowNo');
        //   }
        // }
        // else
        // {
        //   this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds,}).then(() => {
        //     console.log("function called - 0006");
        //     this.createData();
            
        //     if(Vue.prototype.$session.get('CurrentNewsCount'))
        //     {
        //       this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
        //     }
        //     this.refresh = true;  // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30
        //   })

        // }
        // 2024/08/05  #17046 No.20  START
        if(Vue.prototype.$session.get('CurrentRowNo')){
          this.currentArticleNo= Vue.prototype.$session.get('CurrentRowNo');
        }
        // 2024/08/05  #17046 No.20  END
        // 2024/08/05  #17046 No.20  START
        //this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds,}).then(() => {
        this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds, image_flag: true}).then(() => {
        // 2024/08/05  #17046 No.20  END
          this.createData();

          if(Vue.prototype.$session.get('CurrentNewsCount'))
          {
            this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
            // 2021/12/7  #12178  START
            var bodytextview_requestlog = {
                data_info:[{
                contract_id: this.contractId,
                data_section: 2,
                user_id: this.userId,
                read_count:1,
                request_div:3,
                article_id: this.getArraySC[0].article_id,
                user_group_name: this.user_group_name,
              }],
              is_mail:having_mail_key
            }
            if(!this.dialogVisible){
              this.$store.dispatch('communication0008/pdfRequestDisplay',bodytextview_requestlog);
            }
            // 2021/12/7  #12178  END
          }

          // 2021/10/11  #11849  SATRT
          else{
            this.dialogVisible = true
          }
          // 2021/10/11  #11849  END

          this.refresh = true;  // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30
        })
      }
      else
      {
        this.inputParam = Vue.prototype.$session.get('InputParameterFor0006');
        this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
        this.currentAID = Vue.prototype.$session.get('CurrentAID');
        this.currentSID = Vue.prototype.$session.get('CurrentSID');
        if(Vue.prototype.$session.get('CurrentRowNo')){
          this.currentArticleNo= Vue.prototype.$session.get('CurrentRowNo');
        }
        // 2024/08/05  #17046 No.20  START
        this.inputParam.image_flag = true;
        // 2024/08/05  #17046 No.20  END
        //Removed this code since it is already handled in the directive
        // if(this.currentArticleNo == this.currentNewsCount - 1){
        //   this.showNext = false;
        // }
        // When the current article no is 0 means SC article loading first so no need to display Previous button
        // if(this.currentArticleNo == 0){
        //   this.showPrev = false;
        // }else{
        //   this.prevSlideDataSection = 1;
        // }
        if(this.getNikkieArticledata.length > 0){
          this.refresh = true;
          this.createData();
        }else{
          switch(this.currentAID)
          {
            case "0005":
              if(this.currentSID == "0002"){
                this.currentStartNum = 1;
                this.inputParam.start_num = 1;
                this.inputParam.load_num = this.currentNewsCount;
              }
              else{
                this.currentStartNum = this.inputParam.start_num;
              }
              // 2021/11/22  #12270  SATRT
              this.inputParam.Article_Id=Vue.prototype.$session.get('Article_Id');
              this.inputParam.Samuneiru_flag=1;
              // 2021/11/22  #12270  END
              this.$store.dispatch('communication0006/getNewspaperArticles', this.inputParam).then(() => {
                this.createData();
              // 2021/11/22  #12270  SATRT
                this.currentNewsCount= this.getCurrentNewsCount;
                this.currentArticleNo= this.getCurrentRowNo;
              // 2021/11/22  #12270  END
                this.refresh = true;
              })
              break;
            case "0071":
              if(this.currentSID == "0002"){
                this.currentStartNum = 1;
                this.inputParam.start_num = 1;
                this.inputParam.load_num = this.currentNewsCount;
                this.inputParam.contract_kbn = 1;
              }else{
                this.currentStartNum = this.inputParam.start_num;
                this.inputParam.contract_kbn = 1;
              }
              this.$store.dispatch('communication0006/getArticleUsingSearch', this.inputParam).then(() => {
                this.createData();
                this.refresh = true;
              })
              break;
            case "0046":
              this.currentStartNum = 0;
              this.$store.dispatch('communication0006/AID0046_Get', this.inputParam).then(() => {
                this.createData();
                this.refresh = true;
              })
              break;
            //2025/05/21  #19462  START
            case "0109":
                this.currentStartNum = 0;
                this.$store.dispatch('communication0006/AID0109_Get',this.inputParam).then(() => {
                  this.createData();
                  this.refresh = true;
                })
                break;
              //2025/05/21  #19462  END
          }
        }

        // 2021/12/7  #12178  START
        var bodytextview_requestlog = {
            data_info:[{
            contract_id: this.contractId,
            data_section: 2,
            user_id: this.userId,
            read_count:1,
            request_div:3,
            article_id: this.$session.get('Article_Id'),
            user_group_name: this.user_group_name,
          }],
          is_mail:having_mail_key
        }
        if(!this.dialogVisible){
          this.$store.dispatch('communication0008/pdfRequestDisplay',bodytextview_requestlog);
        }
        // 2021/12/7  #12178  END
      }
    }
      this.getConfigurationFromSession();
      this.getMessageInfoFromSession();

    /******Issue fix for 1563 ******/
    if("SID"+this.currentSID == "SID1023"){
      this.fromSID = "SID1024";
    }else{
      this.fromSID = "SID"+this.currentSID;
    }
  },
  computed: {
    ...mapGetters("situation0006", [
      // 2021/11/22  #12270  SATRT
      "getCurrentNewsCount",
      "getCurrentRowNo",
      // 2021/11/22  #12270  END
      "getNewsArticledata",
      "getNikkieArticledata"
    ]),
    ...mapGetters("situation0001", [
      "getScUserAuthority",
      "getUserId",
      "getContractId",
      "getThemeBrowsing",
      "getContractCode",
      "getSC_Pdf_Print_Flag",
      "getMessageInfo",
      "getUserGroupName",
      "getOut_Demand_Confirm_Message_Div_Flag",
      "getDemandConfirmPdfMessage",
      "getDemandConfirmPrintMessage",
      // 2021/10/11  #11849  SATRT
      "getUserGroup_News_Article_Flag",
      "getDemandConfirmTextMessage",
      "getSC_Article_Flag",
      // 2021/10/11  #11849  END
      "getUserGroupLinkageInfo"
    ])
  },
  created(){
    //For the screen Title
    document.title = "記事閲覧";
  },
  updated() {
    if(this.fontSizeChangeFlag == 1)
    {
      $(".smallFontSize span").css("font-size", "calc(10.4pt * 0.8)");
    }
    else if(this.fontSizeChangeFlag == 2)
    {
      $(".mediumFontSize span").css("font-size", "10.4pt");
    }
    else if(this.fontSizeChangeFlag == 3)
    {
      $(".largeFontSize span").css("font-size", "calc(10.4pt * 1.3)");
    }
    else
    {
      //no action needed
    }
  },
  directives: {
    carousel: {
      inserted(el, binding, vnode) {
        var toSlideNo = vnode.context.currentArticleNo;
        var owl = $('.owl-carousel').owlCarousel({
            loop: false,
            nav: true,
            items: 1,
        }).trigger('to.owl.carousel', [toSlideNo,0]);

        /****To hide next button when single record is obtained*****/
        if(vnode.context.currentNewsCount  == 1){
          vnode.context.showNext = false;
        }
        /****To show previous button when showing record other than first record*****/
        if(toSlideNo  > 0 ){
          vnode.context.showPrev = true;
        }
        /****To hide next button when showing last record*****/
        if(vnode.context.currentNewsCount - 1 == toSlideNo){
          vnode.context.showNext = false;
        }
        
        /********Event handler for previous and next button********/
        $('.prev').click(function() {
          owl.trigger('prev.owl.carousel');
        });
        $('.next').click(function() {
          owl.trigger('next.owl.carousel');
        });
        
        /********Event handler for changed event******/
        owl.on('changed.owl.carousel', (event) => {
          vnode.context.isShowing = false;
          // start
          if (event.item.index === 0) {
            vnode.context.showPrev = false;
            vnode.context.showNext = true;
          } else {
            const currnetel = Math.floor(event.item.index + event.page.size);
            // last
            if (currnetel === event.item.count) {
              vnode.context.showPrev = true;
              vnode.context.showNext = false;
            } else {
              vnode.context.showPrev = true;
              vnode.context.showNext = true;
            }
          }

          /*****Code to handle transition between SID0006 and SID0007 when swipe event occurs***/
          var currentDataSection = vnode.context.getArraySC[event.item.index].data_section;
          if(currentDataSection == '1'){
            Vue.prototype.$session.set('CurrentRowNo',event.item.index);
            if(router.currentRoute.name != '0006'){
              router.push({name:'0006',query: vnode.context.queryparam});
            }
          }
        });
      },
    }
  }
};
</script>
<style scoped>
@import "0007.css";
@import "../0009/0009.css";
</style>